var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"hatena-buttone",attrs:{"href":_vm.shareIntent,"target":"_blank"}},[_c('img',{attrs:{"src":require("../assets/images/hatebu.png"),"widgh":"86","height":"20"}})])}
var staticRenderFns = []

export { render, staticRenderFns }